// Phase E2 (May 2026 — reversibility-first architecture).
//
// Pure helpers for TypeToConfirmGate. Extracted into a .ts file
// (not .tsx) so the test runner under the root tsconfig (which
// doesn't enable --jsx) can import the matcher without pulling in
// the React component.

/**
 * Strict-on-content, lenient-on-case + leading/trailing whitespace.
 * Trims input, uppercases both sides, then compares for equality.
 * Internal whitespace must match exactly.
 */
export function matches(input: string, phrase: string): boolean {
  return input.trim().toUpperCase() === phrase.trim().toUpperCase();
}
